export interface Product {
  id: number
  name: string
  image: string
  fallbackImage: string
  originalPrice: number
  currentPrice: number
  pain: string
  description: string
  benefits: string[]
}

export const products: Product[] = [
  {
    id: 1,
    name: 'Power Whey Protein Isolate 2LB',
    image:
      'https://cdn.magicpatterns.com/uploads/uq9ZFq6sQB2gNXbxMmXyvg/Powerwheyprotein2lb.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Power+Whey+Isolate+2LB',
    originalPrice: 3860,
    currentPrice: 3090,
    pain: '¿Entrenas fuerte pero tu músculo no crece? Sin suficiente proteína de alta calidad, tu cuerpo no puede reparar ni construir músculo nuevo. Cada sesión sin proteína adecuada es un esfuerzo desperdiciado.',
    description:
      'La proteína más pura del mercado. El isolate elimina las grasas y lactosa para darte el máximo de proteína por porción. Absorción ultra rápida para que tu músculo reciba lo que necesita exactamente cuando más lo necesita: después del entrenamiento.',
    benefits: [
      'Máxima pureza proteica por porción',
      'Absorción ultra rápida post-entreno',
      'Sin grasas ni lactosa añadida',
      'Ideal para definición muscular',
      'Sabor superior sin sacrificar calidad',
      'Acelera la recuperación muscular',
    ],
  },
  {
    id: 2,
    name: 'Creatina CREAPURE Cibeles 500g',
    image:
      'https://cdn.magicpatterns.com/uploads/2DieQ4qG6bdLeueXPWnWgs/Creatina_500g.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Creatina+CREAPURE+500g',
    originalPrice: 2860,
    currentPrice: 2290,
    pain: '¿Llegás al límite antes de lo que querés? ¿Tus últimas repeticiones se van antes de tiempo? La falta de creatina en tu sistema hace que te quedes corto justo cuando más importa.',
    description:
      'CREAPURE es el estándar de oro mundial en creatina. La marca más respetada por atletas élite, ahora disponible en Uruguay. 500g de creatina monohidratada de la más alta pureza para aumentar tu fuerza, potencia y volumen muscular de forma comprobada científicamente.',
    benefits: [
      'Creatina CREAPURE — la más pura del mundo',
      'Aumenta fuerza y potencia explosiva',
      'Favorece el volumen muscular visible',
      'Retrasa la fatiga muscular',
      'Mejora la recuperación entre series',
      'Certificada y respaldada científicamente',
    ],
  },
  {
    id: 3,
    name: 'Creatina CREAPURE Cibeles 350g',
    image:
      'https://cdn.magicpatterns.com/uploads/quyzsTRBn3hsYrv83rsTae/Creatina350g.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Creatina+CREAPURE+350g',
    originalPrice: 2230,
    currentPrice: 1790,
    pain: 'Querés probar la mejor creatina del mundo pero no querés comprometerte con una presentación grande. Resultado: seguís igual que siempre sin experimentar la diferencia.',
    description:
      'La misma calidad CREAPURE de clase mundial en un formato intermedio, perfecto para empezar tu experiencia con la creatina más pura del mercado o mantener tu suplementación sin stockearte de más.',
    benefits: [
      'Calidad CREAPURE garantizada',
      'Formato intermedio ideal',
      'Pureza superior al 99.9%',
      'Sin sabor, mezcla perfecta',
      'Ideal para iniciarse con creatina',
      'Resultados visibles desde la 2ª semana',
    ],
  },
  {
    id: 4,
    name: 'Creatina CREAPURE Cibeles 150g',
    image:
      'https://cdn.magicpatterns.com/uploads/kQawzkhXSBW37Yn5TgzWZs/Creatina150g.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Creatina+CREAPURE+150g',
    originalPrice: 1110,
    currentPrice: 890,
    pain: 'Nunca probaste creatina porque no querés gastar de más y no sabés si te va a funcionar. Sin probarla, jamás vas a saber lo que estás perdiendo en cada entrenamiento.',
    description:
      'El pack de entrada perfecta al mundo de la creatina CREAPURE. Al precio más accesible del mercado, podés experimentar los beneficios de la creatina más pura y certificada del mundo sin riesgo. Una vez que la probás, no hay vuelta atrás.',
    benefits: [
      'Precio de entrada inigualable',
      'Misma calidad CREAPURE premium',
      'Perfecto para fase de prueba',
      'Sin riesgo de inversión',
      'Resultados comprobables rápido',
      'El impulso que te faltaba',
    ],
  },
  {
    id: 5,
    name: 'Beta Alanina Cibeles CARNOSYNE 180G',
    image:
      'https://cdn.magicpatterns.com/uploads/7896kCbeSUSGLoFucr8yjJ/Betaalalina.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Beta+Alanina+CARNOSYNE+180g',
    originalPrice: 1480,
    currentPrice: 1090,
    pain: '¿El ardor muscular te frena antes de terminar el entrenamiento? ¿Hacés 8 repeticiones cuando podrías hacer 12? La acumulación de ácido láctico te roba repeticiones, series y resultados.',
    description:
      'CARNOSYNE es la forma patentada y más efectiva de beta alanina. Aumenta los niveles de carnosina en el músculo, retrasando la fatiga ácida para que puedas exprimir cada serie hasta el límite real. Más repeticiones = más estímulo = más músculo.',
    benefits: [
      'Beta Alanina patentada CARNOSYNE',
      'Retrasa el ardor y la fatiga muscular',
      'Más repeticiones por serie',
      'Mejora la resistencia muscular',
      'Ideal para entrenamientos de alta intensidad',
      'Potencia tu rendimiento en cardio y pesas',
    ],
  },
  {
    id: 6,
    name: 'PVP Power Vegan Protein 2LB',
    image:
      'https://cdn.magicpatterns.com/uploads/8XvZAkvT4pM2zRR2yWeSrx/Power_vegan_protein.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Power+Vegan+Protein+2LB',
    originalPrice: 3480,
    currentPrice: 2790,
    pain: '¿Seguís una dieta vegana o vegetariana y creés que tenés que sacrificar tus resultados? Eso era antes. Hoy la ciencia y CIBELES te dan la proteína completa que necesitás sin comprometer tus valores.',
    description:
      'Proteína vegetal de alta calidad que no le pide nada a la whey convencional. Perfil de aminoácidos completo, digestión excelente y sabor sorprendente. Demostrá que el rendimiento de élite no depende de productos de origen animal.',
    benefits: [
      '100% proteína de origen vegetal',
      'Perfil de aminoácidos completo',
      'Alta digestibilidad sin malestar',
      'Sin lactosa, sin gluten',
      'Ideal para veganos y deportistas',
      'Sabor y textura de calidad premium',
    ],
  },
  {
    id: 7,
    name: 'Power Whey Protein Isolate 4 LB',
    image:
      'https://cdn.magicpatterns.com/uploads/amhzhq63fgh5pkD7ND4mgW/Powerwheyprotein4lb.png',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Power+Whey+Protein+Isolate+4LB',
    originalPrice: 7230,
    currentPrice: 5790,
    pain: "¿Estás cansado de quedarte sin proteína a mitad de mes y frenar tu progreso? O peor, comprás un bote pequeño más caro por porción porque 'ahorrás' inicialmente. El ciclo de escasez destruye tu continuidad.",
    description:
      'El bote grande para el atleta serio. 4 libras de la mejor whey protein de CIBELES garantizan tu suplementación por un período extendido sin interrupciones. Más por menos, más consistencia, más resultados. Para los que van en serio.',
    benefits: [
      '4 LB — máxima duración y ahorro',
      'Alta concentración proteica por porción',
      'Ideal para atletas de entrenamiento frecuente',
      'Mejor costo por porción del mercado',
      'Sostenés tu suplementación sin cortes',
      'Músculo constante = resultados constantes',
    ],
  },
  {
    id: 8,
    name: 'Extreme Gainer Cibeles 5LB',
    image:
      'https://cdn.magicpatterns.com/uploads/n84ViFWRnEJgfPijkXenPe/ExtremeGainer.png',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Extreme+Gainer+5LB',
    originalPrice: 4230,
    currentPrice: 3390,
    pain: '¿Sos de los que come de todo y no aumenta ni un kilo? Metabolismo rápido, poco apetito, agenda ocupada. Entrenás pero el peso no sube. Tu cuerpo está en déficit calórico crónico y no lo sabés.',
    description:
      'La solución definitiva para hardgainers. El Extreme Gainer CIBELES combina carbohidratos de calidad con proteína para crear el superávit calórico que necesitás para crecer. 5 libras de combustible puro para los que quieren masa muscular de verdad.',
    benefits: [
      'Superávit calórico controlado y efectivo',
      'Mezcla proteína + carbohidratos de calidad',
      'Ideal para hardgainers y ectomorfos',
      '5 LB de duración extendida',
      'Acelera la ganancia de masa muscular',
      'Energía sostenida para entrenar más',
    ],
  },
  {
    id: 9,
    name: 'Whey Protein Cibeles 2 LB',
    image:
      'https://cdn.magicpatterns.com/uploads/bwMKwpYQ7U6NqnWXDTuHMp/Whey_Protein_Cibeles2lb.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Whey+Protein+2LB',
    originalPrice: 3230,
    currentPrice: 2590,
    pain: 'Querés empezar con proteína pero no te animás a invertir en un formato grande. Resultado: seguís sin suplementarte, tus músculos no reciben lo que necesitan y el progreso se estanca.',
    description:
      'El punto de entrada perfecto a la suplementación con proteína de calidad. 2 libras de whey protein CIBELES con todos los aminoácidos esenciales que tu músculo necesita para crecer y recuperarse. Calidad sin excusas, precio justo.',
    benefits: [
      'Formato accesible para empezar',
      'Proteína completa con aminoácidos esenciales',
      'Ideal para empezar a suplementarse',
      'Fácil de incorporar a tu rutina diaria',
      'Recuperación muscular acelerada',
      'Base fundamental de cualquier plan de nutrición',
    ],
  },
  {
    id: 10,
    name: 'Whey Protein Cibeles 4 LB',
    image:
      'https://cdn.magicpatterns.com/uploads/xjQLVWgkkVp9hcLxyfqdVt/Whey_Protein_Cibeles4lb.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Whey+Protein+4LB',
    originalPrice: 5480,
    currentPrice: 4390,
    pain: 'Ya sabés lo que es la whey y la necesitás de forma consistente. Cada vez que se te acaba, perdés días sin suplementarte y eso afecta tu progreso semana a semana.',
    description:
      'Para el atleta que ya sabe que la proteína es no-negociable. 4 libras de whey protein CIBELES para mantener tu suplementación sin interrupciones, con el mejor costo por porción y la calidad que ya conocés y confiás.',
    benefits: [
      '4 LB para suplementación continua',
      'Mejor costo-beneficio por porción',
      'Proteína completa de alta absorción',
      'Para atletas de entrenamiento regular',
      'Sin cortes en tu suplementación',
      'Resultados sostenidos en el tiempo',
    ],
  },
  {
    id: 11,
    name: 'Testrol UP 90 Caps — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/oADxySTgDijT2vdUrbFtrS/Testrol_Up.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Testrol+UP+90+Caps',
    originalPrice: 1110,
    currentPrice: 890,
    pain: '¿Sentís que tu rendimiento en el gym se estancó? ¿Te falta esa energía y potencia que tenías antes? Con el paso del tiempo, los niveles hormonales bajan y tu cuerpo lo nota en cada entrenamiento.',
    description:
      'Testrol UP de Profit es un potenciador natural de testosterona formulado con ingredientes de alta calidad. Diseñado para hombres activos que buscan optimizar su rendimiento, fuerza y vitalidad de forma segura y natural. 90 cápsulas para un ciclo completo.',
    benefits: [
      'Potenciador natural de testosterona',
      'Mejora la fuerza y el rendimiento físico',
      'Aumenta la energía y vitalidad diaria',
      'Fórmula con ingredientes de alta pureza',
      '90 cápsulas — ciclo completo',
      'Ideal para hombres activos de 25+ años',
    ],
  },
  {
    id: 12,
    name: 'Vaso Shaker 750ML — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/beMMMADNdYbCoCHKdfJXVg/Shaker.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Shaker+750ML',
    originalPrice: 360,
    currentPrice: 290,
    pain: '¿Seguís mezclando tu proteína con un tenedor en un vaso cualquiera? Los grumos, las pérdidas y la incomodidad de llevar tu suplemento al gym te quitan ganas de ser constante.',
    description:
      'El Shaker Profit de 750ML es el compañero perfecto para tu suplementación. Con sistema anti-grumos, tapa hermética y diseño ergonómico, preparar tu batido es rápido, limpio y sin excusas. Llevalo al gym, a la oficina o a donde vayas.',
    benefits: [
      'Capacidad de 750ML — tamaño ideal',
      'Sistema anti-grumos integrado',
      'Tapa hermética — sin derrames',
      'Diseño ergonómico y resistente',
      'Fácil de limpiar y transportar',
      'Accesorio esencial para tu rutina',
    ],
  },
  {
    id: 13,
    name: 'Isolate Vegan Pro 430g — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/dL2RjtNGciFMhds81KHz81/Isolate_Vegan_Pro.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Isolate+Vegan+Pro+430g',
    originalPrice: 2360,
    currentPrice: 1890,
    pain: '¿Sos vegano y sentís que no encontrás una proteína que realmente rinda? La mayoría de las opciones vegetales tienen mal sabor, poca proteína por porción y precios ridículos.',
    description:
      'Isolate Vegan Pro de Profit es una proteína vegetal aislada de alta concentración, con perfil completo de aminoácidos y excelente digestibilidad. 430g de proteína premium para atletas que eligen no consumir productos de origen animal sin sacrificar resultados.',
    benefits: [
      'Proteína vegetal aislada de alta pureza',
      'Perfil completo de aminoácidos esenciales',
      'Excelente digestibilidad sin malestar',
      'Sin lactosa, sin gluten, 100% vegana',
      'Sabor agradable y fácil de mezclar',
      'Ideal para definición y recuperación',
    ],
  },
  {
    id: 14,
    name: 'Pro Abdomen 60 Caps — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/kAprmK88P6DQyeVRcH72oe/Pro_abdomen.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Pro+Abdomen+60+Caps',
    originalPrice: 1110,
    currentPrice: 890,
    pain: '¿Entrenás abdominales todos los días pero la grasa abdominal no se va? Por más ejercicio que hagas, sin el apoyo metabólico correcto, esa capa de grasa sigue tapando tu progreso.',
    description:
      'Pro Abdomen de Profit es un suplemento termogénico diseñado para potenciar la quema de grasa abdominal. Con ingredientes que aceleran el metabolismo y favorecen la definición, es el complemento perfecto para tu dieta y entrenamiento.',
    benefits: [
      'Potencia la quema de grasa localizada',
      'Acelera el metabolismo naturalmente',
      'Favorece la definición abdominal',
      'Complemento ideal para dieta y cardio',
      '60 cápsulas — fácil de tomar',
      'Resultados visibles con constancia',
    ],
  },
  {
    id: 15,
    name: 'Colágeno Hidrolizado 150 Caps — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/ub8azdV6UsWeyx9ohY66xD/Colageno_hidrolizado.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Colageno+150+Caps',
    originalPrice: 1110,
    currentPrice: 890,
    pain: '¿Te duelen las articulaciones después de entrenar? ¿Tu piel perdió firmeza y tus uñas se quiebran fácil? Tu cuerpo está pidiendo colágeno y no se lo estás dando.',
    description:
      'Colágeno Hidrolizado de Profit en cápsulas, la forma más práctica de cuidar tus articulaciones, piel, cabello y uñas. 150 cápsulas de colágeno de alta absorción para deportistas que exigen mucho a su cuerpo y quieren protegerlo desde adentro.',
    benefits: [
      'Protege articulaciones y tendones',
      'Mejora la elasticidad de la piel',
      'Fortalece cabello y uñas',
      'Alta absorción — colágeno hidrolizado',
      '150 cápsulas — duración extendida',
      'Esencial para deportistas de alto impacto',
    ],
  },
  {
    id: 16,
    name: 'Glutamine Powder 150g — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/iHoT4sEqJxMwsWZTEiAQXU/Glutamina_powder.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Glutamine+150g',
    originalPrice: 1240,
    currentPrice: 990,
    pain: '¿Tardás días en recuperarte de un entrenamiento intenso? ¿Sentís que tu sistema inmune se debilita cuando entrenás fuerte? Tu cuerpo consume glutamina más rápido de lo que la produce.',
    description:
      'Glutamine Powder de Profit es L-Glutamina pura en polvo, el aminoácido más abundante en el músculo. Acelera la recuperación post-entreno, protege la masa muscular y fortalece el sistema inmunológico. 150g de recuperación pura.',
    benefits: [
      'L-Glutamina pura — sin aditivos',
      'Acelera la recuperación muscular',
      'Protege la masa muscular del catabolismo',
      'Fortalece el sistema inmunológico',
      'Sin sabor — mezcla con cualquier bebida',
      'Ideal para entrenamientos de alta intensidad',
    ],
  },
  {
    id: 17,
    name: 'Creatine POWER 300g — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/q3RDtF2NWCAX2QVF63RYRC/Creatine_pwoder.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Creatine+Power+300g',
    originalPrice: 990,
    currentPrice: 790,
    pain: '¿Querés probar creatina pero las opciones premium se van de presupuesto? Seguís entrenando sin ese plus de fuerza y potencia que marca la diferencia en cada serie.',
    description:
      'Creatine POWER de Profit es creatina monohidratada de calidad a un precio accesible. 300g para potenciar tu fuerza, aumentar el volumen muscular y mejorar tu rendimiento en cada entrenamiento. La entrada perfecta al mundo de la creatina.',
    benefits: [
      'Creatina monohidratada de calidad',
      'Aumenta fuerza y potencia explosiva',
      'Favorece el volumen muscular',
      '300g — excelente relación precio-calidad',
      'Sin sabor — fácil de mezclar',
      'Resultados comprobados científicamente',
    ],
  },
  {
    id: 18,
    name: 'Isolate Protein Mix 900g — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/ebdbwLR9YYnnU32xaXdJFi/Isolate_protein_mix.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Isolate+Protein+Mix+900g',
    originalPrice: 1490,
    currentPrice: 1190,
    pain: '¿Necesitás proteína de calidad pero tu presupuesto no alcanza para las marcas premium? Seguís sin suplementarte y tus músculos pagan el precio de cada entrenamiento sin recuperación adecuada.',
    description:
      'Isolate Protein Mix de Profit combina proteína aislada con concentrada para darte el mejor balance entre pureza, sabor y precio. 900g de proteína de alta calidad con aminoácidos esenciales para crecer y recuperarte sin romper el presupuesto.',
    benefits: [
      'Mix de proteína aislada + concentrada',
      'Alta concentración proteica por porción',
      '900g — gran duración y rendimiento',
      'Excelente sabor y disolución',
      'Aminoácidos esenciales completos',
      'Mejor relación calidad-precio del mercado',
    ],
  },
  {
    id: 19,
    name: 'Omega 3 Premium 60 Caps — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/e6p8vcEvkixbVqamiyQHG7/Omega_3_.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Omega+3+Premium+60+Caps',
    originalPrice: 1240,
    currentPrice: 990,
    pain: '¿Sabés que deberías tomar Omega 3 pero nunca lo hacés? La inflamación silenciosa afecta tu recuperación, tu corazón y hasta tu concentración sin que te des cuenta.',
    description:
      'Omega 3 Premium de Profit aporta ácidos grasos esenciales EPA y DHA de alta concentración. Reduce la inflamación, protege el sistema cardiovascular y mejora la recuperación muscular. 60 cápsulas de salud integral para el deportista completo.',
    benefits: [
      'EPA y DHA de alta concentración',
      'Reduce la inflamación post-entreno',
      'Protege el sistema cardiovascular',
      'Mejora la recuperación muscular',
      'Beneficia la salud cerebral y articular',
      '60 cápsulas — fácil de incorporar',
    ],
  },
  {
    id: 20,
    name: 'Anabolic MASS 28500 3kg — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/3a2vVnSjXyQF7cG2wEnThv/Anabolic_Mass.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Anabolic+Mass+3kg',
    originalPrice: 1860,
    currentPrice: 1490,
    pain: '¿Comés de todo y no subís ni un kilo? Tu metabolismo quema calorías más rápido de lo que las consumís. Sin un superávit calórico real, tu cuerpo no tiene material para construir músculo nuevo.',
    description:
      'Anabolic MASS 28500 de Profit es el hipercalórico más completo del mercado. Con 28.500mg de activos por porción, combina proteínas, carbohidratos complejos, creatina y glutamina en 3kg de puro combustible para ganar masa muscular de verdad.',
    benefits: [
      '28.500mg de activos por porción',
      'Proteínas + carbohidratos + creatina + glutamina',
      '3kg — máxima duración y rendimiento',
      'Ideal para hardgainers y ectomorfos',
      'Superávit calórico controlado y efectivo',
      'Ganancia de masa muscular comprobada',
    ],
  },
  {
    id: 21,
    name: 'Pre Workout Fire Gun 300g — Profit',
    image:
      'https://cdn.magicpatterns.com/uploads/fA8siqzMtYyYHZAdKvrdD7/Fire_Gun.jpg',
    fallbackImage:
      'https://via.placeholder.com/400x400/1a1a1a/D4A017?text=Fire+Gun+Pre+Workout+300g',
    originalPrice: 1740,
    currentPrice: 1390,
    pain: '¿Llegás al gym sin energía después de un día largo? ¿Tus entrenamientos son mediocres porque no tenés la intensidad que necesitás? Sin el estímulo correcto, cada sesión es una oportunidad desperdiciada.',
    description:
      'Fire Gun de Profit es un pre-entreno de alta potencia formulado para darte energía explosiva, foco mental y resistencia superior. 300g de pura intensidad con cafeína, beta-alanina y arginina para que cada entrenamiento sea el mejor de tu vida.',
    benefits: [
      'Energía explosiva desde la primera toma',
      'Foco mental y concentración máxima',
      'Mayor resistencia y potencia en cada serie',
      'Con cafeína, beta-alanina y arginina',
      '300g — múltiples porciones de alto impacto',
      'Sentí la diferencia desde el primer entreno',
    ],
  },
]

export const WA_NUMBER = '59894348746'
